import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION1: PdfComponent = {
  type: 'section',
  id: 's2s1',
  title: '1. Permitted Goods and Services',
  content: [
    {
      type: 'altText',
      id: 's1s1heading',
      content: [
        'Kanda permits finance to be offered for a wide range of goods and services. Accordingly, there is no fixed list of “Permitted Goods and Services” for the purposes of this Agreement. However, the following conditions apply:',
      ],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's1s1bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Kanda reserves the right, at its sole discretion, to review, approve or restrict finance in relation to particular product or service categories, either on a case-by-case basis or across an entire sector.',
        },
        {
          copy: 'The Subscriber must notify Kanda in writing if it intends to introduce finance for any new category of goods or services not previously submitted to Kanda. Kanda shall confirm whether such category is permitted.',
        },
        {
          copy: "Kanda may, at any time, audit Credit Agreements and underlying transactions to verify that financed goods and/or services are appropriate, lawful, and within Kanda's acceptable business practices and underwriting guidelines.",
        },
        {
          copy: {
            type: 'altText',
            id: 's2s1credit',
            content: [
              'Where Kanda reasonably determines that a Credit Agreement has been used to finance goods or services it deems outside the scope of acceptable risk or regulatory alignment, Kanda may treat the transaction as an ',
              'Exception',
              ', and the Subscriber may be required to refund the value of the relevant advance or take remedial steps as directed by Kanda.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'Kanda may issue guidance from time to time identifying sectors or activities that are restricted or require enhanced due diligence prior to approval. The Subscriber agrees to comply with any such guidance.',
        },
      ],
      prefix: '1',
    },
  ],
};
